export const SET_MESSAGE = "CONFIG/SET_MESSAGE";
